// src/config.js
export const CONFIG = {
  IMAGES_BASE: "https://backend.regencyinterior.com/images",
  UPLOAD_URL: "https://backend.regencyinterior.com/upload",
  WEB3FORMS_ACCESS_KEY: "e19ae728-e0e4-480e-9782-7a890ff74b1d",
  FORM_NOTIFICATION_EMAIL: "interiorregency6@gmail.com",
  ADMIN_EMAILS: [
    "adityasp193@gmail.com",
    "adityasureshpatil41@gmail.com",
    "interiorregency6@gmail.com",
  ],
};
